import React from "react";

import useGetCategoryHook from "../hooks/useGetCategoryHook";
import useGetOptionHook from "../hooks/useGetOptionHook";

import { Category } from "../data/Category";
import { Option } from "../data/Option";
import { useCategoryTabStore } from "../store/CategoryTabStore";

type CategoriesContextProps = {
    categories: Category[] | undefined;
    isCategoriesFetching: boolean;
    refetchCategories: () => void;

    options: Option[] | undefined;
    isOptionsFetching: boolean;
    refetchOptions: () => void;
};

const CategoryContext = React.createContext<CategoriesContextProps>(null!);

export function CategoryProvider({ children }: { children: React.ReactNode }) {
    const { selectedCategory } = useCategoryTabStore();

    const { categories, isCategoriesFetching, refetchCategories } = useGetCategoryHook();
    const { options, isOptionsFetching, refetchOptions } = useGetOptionHook(selectedCategory?.id);

    return (
        <CategoryContext.Provider value={{
            categories, isCategoriesFetching, refetchCategories,
            options, isOptionsFetching, refetchOptions
        }}>
            {children}
        </CategoryContext.Provider>
    );
}

export function useCategoryContext() {
    return React.useContext(CategoryContext);
}
